import { useEffect, useState } from "react";
import { leaveAPI } from '../../api/leaveAPI';

export default function Department({ pcode, selectedDepartment, setSelectedDepartment }) {
    const [departments, setDepartments] = useState([]);
    const [selectAll, setSelectAll] = useState(true);

    useEffect(() => {
        setSelectedDepartment('');

        if (!pcode || pcode.trim().length === 0) {
            setDepartments([]);
            return;
        }

        leaveAPI.getDepartments(pcode).then((data) => setDepartments(data));
    }, [pcode])

    const onChangeSelectAll = (e) => {
        const checked = e.target.checked;
        setSelectAll(checked);
        if (checked) setSelectedDepartment('');
    }

    const onChangeDepartment = (e) => {
        setSelectedDepartment(e.target.value);
    }

    return (
        <div className="d-flex align-items-center gap-2 w-100">
            <select
                className="form-select"
                value={selectedDepartment}
                onChange={onChangeDepartment}
                disabled={selectAll}
            >
                <option value="">Select Department</option>
                {
                    departments.map((data) => (
                        <option key={data.departmentCode} value={data.departmentCode}>
                            {data.departmentCode} - {data.departmentName}
                        </option>
                    ))
                }
            </select>
            <div className="form-check text-nowrap">
                <input
                    type="checkbox"
                    className="form-check-input"
                    id="selectAllDepartments"
                    checked={selectAll}
                    onChange={onChangeSelectAll}
                />
                <label className="form-check-label" htmlFor="selectAllDepartments">All</label>
            </div>
        </div>
    );
}
